<template>
  <PageWrapper
    cardClass="shadow-none"
    isChildWrapper
    isDense
    :isLoading="isLoading"
  >
    <template #title> امتیاز نمایشی استاد </template>
    <BRow>
      <BCol cols="12" md="6">
        <TextInput
          inputId="powerTransmission"
          inputLabel="قدرت انتقال"
          inputPlaceholder="40"
          type="number"
          v-model="masterPoints.powerTransmission"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          inputId="discipline"
          inputLabel="نظم"
          inputPlaceholder="100"
          type="number"
          v-model="masterPoints.discipline"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          inputId="cancellationRate"
          inputLabel="کنسلی"
          inputPlaceholder="20"
          type="number"
          v-model="masterPoints.cancellationRate"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          inputId="classCalmness"
          inputLabel="آرامش کلاس"
          inputPlaceholder="85"
          type="number"
          v-model="masterPoints.classCalmness"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          inputId="respect"
          inputLabel="احترام"
          inputPlaceholder="60"
          type="number"
          v-model="masterPoints.respect"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          inputId="punctuality"
          inputLabel="وقت شناسی"
          inputPlaceholder="90"
          type="number"
          v-model="masterPoints.punctuality"
        ></TextInput>
      </BCol>
      <BCol cols="12">
        <div class="w-100 d-flex align-items-center justify-content-end">
          <BButton
            variant="success"
            class="ml-auto"
            @click="updateMasterPoints"
          >
            بروزرسانی امتیاز ها
          </BButton>
        </div>
      </BCol>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    currentMasterPoints: {
      type: Object,
      required: false,
    },
    masterUserId: {
      type: [String, Number],
      required: false,
    },
  },
  emits: ["refetch"],

  watch: {
    currentMasterPoints: {
      handler(val) {
        if (val) {
          this.masterPoints = JSON.parse(JSON.stringify(val));
          console.log(this.masterUserId);
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  data() {
    return {
      isLoading: false,
      masterPoints: {
        powerTransmission: null,
        discipline: null,
        cancellationRate: null,
        classCalmness: null,
        respect: null,
        punctuality: null,
      },
    };
  },
  methods: {
    async updateMasterPoints() {
      try {
        this.isLoading = true;

        const _this = this;
        const updateMasterPoints = new UpdateMasterPoints(_this);

        updateMasterPoints.setRequestParam({
          userId: _this.masterUserId,
        });
        updateMasterPoints.setRequestParamDataObj(_this.masterPoints);

        await updateMasterPoints.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "امتیاز نمایشی کاربر ویرایش شد",
              },
            });
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: response.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    TextInput,
    BRow,
    BCol,
    BButton,
  },
};
import { BRow, BCol, BButton } from "bootstrap-vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { UpdateMasterPoints } from "@/libs/Api/Users";
</script>
